
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { ISiteNameWithId } from '../../../ts/ServerApi/types/ISiteNameWithId';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { IView } from '../../../ts/ServerApi/types/IView';
import { INamedItem } from '../../../ts/ServerApi/types/resourceParts';
import { IAccelerationTask } from '../types/IAccelerationTask';

export interface IGetAccelerationTasksResult extends IGetItemsResult {
  tasks: IAccelerationTask[];
  workbooks: INamedItem[];
  users: IUser[];
  views: IView[];
  projects: INamedItem[];
  sites: ISiteNameWithId[];
}

export class GetAccelerationTasksRequest extends Request<IGetItemsParams, IGetAccelerationTasksResult> {
  constructor(params: IGetItemsParams) {
    super('getAccelerationTasks', params);
  }
}
